import { render, staticRenderFns } from "./maintenRecord.vue?vue&type=template&id=dfb61f3c&scoped=true"
import script from "./maintenRecord.vue?vue&type=script&lang=js"
export * from "./maintenRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb61f3c",
  null
  
)

export default component.exports